module.exports = __webpack_public_path__ + "static/milestone-98deb0da36f4028b2a9e796b3d97be13.png";